import {
  DeprecatedDropdown,
  DeprecatedDropdownButton,
  DeprecatedDropdownItem,
  DeprecatedDropdownMenu,
} from "@deere/fuel-react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import { Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

type TooltipProps = {
  title: string;
  disableFocusListener?: boolean;
  disableHoverListener?: boolean;
  disableTouchListener?: boolean;
};
type props = {
  onAddRows: (noOfRows: number) => void;
  disabled: boolean;
  toolTipProps?: TooltipProps;
};

function AddRowDropdown({ onAddRows, disabled, toolTipProps }: props) {
  const { t } = useTranslation("common");
  return (
    <DeprecatedDropdown>
      {toolTipProps !== undefined ? (
        <Tooltip {...toolTipProps}>
          <DeprecatedDropdownButton
            startIcon={<AddCircleOutlineIcon />}
            data-testid="add-row-button"
            variant="text"
            disabled={disabled}
          >
            {t("table.addARow.button")}
          </DeprecatedDropdownButton>
        </Tooltip>
      ) : (
        <DeprecatedDropdownButton
          startIcon={<AddCircleOutlineIcon />}
          data-testid="add-row-button"
          variant="text"
          disabled={disabled}
        >
          {t("table.addARow.button")}
        </DeprecatedDropdownButton>
      )}
      <DeprecatedDropdownMenu>
        <DeprecatedDropdownItem
          data-testid="add-one-row-button"
          onClick={() => onAddRows(1)}
        >
          {t("table.addARow.add.one.row.button")}
        </DeprecatedDropdownItem>
        <DeprecatedDropdownItem
          data-testid="add-ten-row-button"
          onClick={() => onAddRows(10)}
        >
          {t("table.addARow.add.ten.rows.button")}
        </DeprecatedDropdownItem>
        <DeprecatedDropdownItem
          data-testid="add-twenty-row-button"
          onClick={() => onAddRows(20)}
        >
          {t("table.addARow.add.twenty.rows.button")}
        </DeprecatedDropdownItem>
        <DeprecatedDropdownItem
          data-testid="thirty-row-button"
          onClick={() => onAddRows(30)}
        >
          {t("table.addARow.add.thirty.rows.button")}
        </DeprecatedDropdownItem>
      </DeprecatedDropdownMenu>
    </DeprecatedDropdown>
  );
}

export default AddRowDropdown;
